import React, { useCallback } from 'react';
import { OptionsObject, useSnackbar } from 'notistack';
import { Alert, AlertColor, AlertTitle } from '@mui/material';
import { ReactComponent as SuccessIcon } from '../assets/images/snackbar/Success.svg';
import { ReactComponent as WarningIcon } from '../assets/images/snackbar/Warning.svg';
import { ReactComponent as InfoIcon } from '../assets/images/snackbar/Info.svg';
import { ReactComponent as ErrorIcon } from '../assets/images/snackbar/Error.svg';

type NotistackOptionsObject = typeof OptionsObject;

export const useCustomSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const customEnqueueSnackbar = useCallback(
    (message: string, variant: AlertColor, title?: string, options?: NotistackOptionsObject, icon?: string) => {
      enqueueSnackbar(message, {
        ...options,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        content: (key, text) => (
          <Alert
            id={`${key}`}
            iconMapping={{
              success: <SuccessIcon />,
              warning: <WarningIcon />,
              info: <InfoIcon />,
              error: <ErrorIcon />,
            }}
            className={options?.onClick && 'with-action'}
            onClick={() => {
              if (options?.onClick) closeSnackbar(key);
            }}
            onClose={(event) => {
              event.stopPropagation();
              closeSnackbar(key);
            }}
            severity={variant}
            sx={{ width: '100%' }}
            icon={icon && <img src={icon} alt="notification" className="notification-icon" />}
          >
            {title && <AlertTitle>{title}</AlertTitle>}
            <p>{text}</p>
          </Alert>
        ),
      });
    },
    [closeSnackbar, enqueueSnackbar],
  );

  return { customEnqueueSnackbar };
};
